
import { useState } from 'react';

const mundos = [
  {
    mundo: 'MUNDO 1',
    tema: 'Fundamentos & Arquitectura',
    color: '#5B3A8B',
    border: '#3B0764',
    emoji: '🏰',
    conceptos: [
      { nombre: 'Arquitectura de Software', desc: 'Estructura de alto nivel: módulos, comunicación y tecnologías para cumplir requisitos funcionales y no funcionales.' },
      { nombre: 'Modularidad', desc: 'División del sistema en piezas independientes con responsabilidades claras e interfaces definidas.' },
      { nombre: 'Separación en Capas', desc: 'Presentación, Aplicación, Dominio y Acceso a Datos. Cada capa tiene una responsabilidad específica.' },
      { nombre: 'Escalabilidad', desc: 'Capacidad del sistema de crecer sin degradar el rendimiento. Horizontal (más servidores) vs Vertical (más recursos).' },
      { nombre: 'Mantenibilidad', desc: 'Facilidad para entender, corregir y refactorizar el código sin romper funcionalidades existentes.' },
      { nombre: 'Arquitectura Monolítica', desc: 'Todo el sistema en un solo despliegue. Simple al inicio, difícil de escalar independientemente.' },
      { nombre: 'Microservicios', desc: 'Sistema dividido en servicios pequeños e independientes, cada uno con su propia base de datos y despliegue.' },
      { nombre: 'Serverless', desc: 'Ejecución de código sin gestionar servidores. El proveedor escala automáticamente según demanda.' },
      { nombre: 'Arquitectura Cliente Servidor', desc: 'Modelo de comunicación donde el cliente solicita servicios al servidor. El servidor procesa y responde. Base del modelo web actual.' },
    ],
  },
  {
    mundo: 'MUNDO 2',
    tema: 'Backend & APIs',
    color: '#228B22',
    border: '#145214',
    emoji: '⚙️',
    conceptos: [
      { nombre: 'REST', desc: 'Representational State Transfer. Arquitectura para APIs usando HTTP con recursos, verbos y códigos de estado.' },
      { nombre: 'HTTP Verbos', desc: 'GET (leer), POST (crear), PUT/PATCH (actualizar), DELETE (eliminar). Cada uno tiene semántica específica.' },
      { nombre: 'Códigos de Estado', desc: '2xx éxito, 3xx redirección, 4xx error cliente, 5xx error servidor. Ej: 200, 201, 400, 401, 404, 500.' },
      { nombre: 'Backend as a Service', desc: 'Plataforma que proporciona servicios de backend sin gestionar infraestructura. APIs como servicio, autenticación, BD en la nube.' },
      { nombre: 'Supabase', desc: 'Plataforma BaaS basada en PostgreSQL. Proporciona API REST/GraphQL, autenticación, realtime, storage y edge functions.' },
    ],
  },
  {
    mundo: 'MUNDO 3',
    tema: 'Frontend & Web',
    color: '#C8860A',
    border: '#8B6914',
    emoji: '🎨',
    conceptos: [
      { nombre: 'HTML Básico', desc: 'Estructura base de un documento HTML y uso de etiquetas esenciales para crear contenido web.' },
      { nombre: 'Selectores CSS', desc: 'Uso de selectores para aplicar estilos: por etiqueta, clase, id, descendencia y combinaciones básicas.' },
    ],
  },
  {
    mundo: 'MUNDO 4',
    tema: 'Scrum & Agile',
    color: '#1b3d70',
    border: '#0d2040',
    emoji: '📋',
    conceptos: [
      { nombre: 'Agile', desc: 'Enfoque iterativo e incremental para entregar valor continuo y adaptarse rápido al cambio.' },
      { nombre: 'Scrum', desc: 'Framework ágil basado en sprints, roles y eventos para organizar el trabajo en equipo.' },
      { nombre: 'Daily Scrum', desc: 'Reunión diaria corta (15 min) para sincronizar al equipo y revisar el avance del sprint.' },
      { nombre: 'Sprint', desc: 'Período fijo de trabajo (normalmente 1 a 4 semanas) donde se construye un incremento del producto.' },
      { nombre: 'Product Owner', desc: 'Responsable de maximizar el valor del producto y priorizar el trabajo del equipo en Scrum.' },
      { nombre: 'Product Master', desc: 'Rol de facilitación del proceso Scrum para asegurar que se sigan prácticas ágiles y remover impedimentos.' },
    ],
  },
];

export default function ConceptosSection() {
  const [activeMundo, setActiveMundo] = useState(0);
  const [search, setSearch] = useState('');

  const currentMundo = mundos[activeMundo];
  const filtered = currentMundo.conceptos.filter(
    c => c.nombre.toLowerCase().includes(search.toLowerCase()) || c.desc.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <section className="py-16 md:py-24 relative" style={{ background: '#FAFAF8' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Section header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-block bg-[#C8860A] border-4 border-[#8B6914] px-5 py-2 mb-4 shadow-[4px_4px_0px_#8B6914]">
            <span className="text-white font-black text-xs tracking-widest uppercase" style={{ fontFamily: "'Press Start 2P', monospace" }}>
              ITEM CATALOG
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1b3d70] mb-4">
            Conceptos del Examen
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
            Tu inventario de conocimiento. Domina estos conceptos y estarás listo para cualquier nivel.
          </p>
        </div>

        {/* World selector */}
        <div className="flex flex-wrap gap-3 justify-center mb-8">
          {mundos.map((m, i) => (
            <button
              key={i}
              onClick={() => { setActiveMundo(i); setSearch(''); }}
              className={`flex items-center gap-2 px-4 py-2 border-4 font-black text-sm transition-all duration-200 shadow-[3px_3px_0px_rgba(0,0,0,0.3)] hover:shadow-[5px_5px_0px_rgba(0,0,0,0.4)] hover:-translate-y-0.5 whitespace-nowrap cursor-pointer ${
                activeMundo === i ? 'text-white scale-105' : 'bg-white text-gray-700'
              }`}
              style={activeMundo === i ? { background: m.color, borderColor: m.border } : { borderColor: m.border }}
            >
              <span>{m.emoji}</span>
              <span className="hidden sm:inline">{m.mundo}:</span>
              <span>{m.tema}</span>
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="relative max-w-md mx-auto mb-8">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
            <i className="ri-search-line text-gray-400"></i>
          </div>
          <input
            type="text"
            placeholder="Buscar concepto..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-3 border-4 text-sm font-medium focus:outline-none transition-all"
            style={{ borderColor: currentMundo.border, fontFamily: 'inherit' }}
          />
        </div>

        {/* Concepts grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {filtered.map((concepto, i) => (
            <div
              key={i}
              className="flex gap-4 p-4 md:p-5 border-l-4 bg-white shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-0.5"
              style={{ borderLeftColor: currentMundo.color }}
            >
              <div
                className="w-8 h-8 flex-shrink-0 flex items-center justify-center font-black text-white text-xs rounded-none"
                style={{ background: currentMundo.color }}
              >
                {i + 1}
              </div>
              <div>
                <h4 className="font-black text-[#1b3d70] text-sm md:text-base mb-1">{concepto.nombre}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{concepto.desc}</p>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div className="col-span-2 text-center py-12 text-gray-400">
              <div className="text-4xl mb-3">🔍</div>
              <p className="font-bold">No se encontraron conceptos con ese término.</p>
            </div>
          )}
        </div>

        {/* Count */}
        <div className="text-center mt-8">
          <span className="inline-block px-4 py-2 border-2 text-sm font-bold" style={{ borderColor: currentMundo.border, color: currentMundo.color }}>
            {filtered.length} de {currentMundo.conceptos.length} conceptos
          </span>
        </div>
      </div>
    </section>
  );
}
